import produce from "immer";
import { myCommissionReportActions } from ".";
import { IStoreState } from "../initialStoreState";
import { initialMyCommissionReportState } from "./myCommissionReport.types";
import {
  CLEAR_MY_COMMISSION_REPORTS_STATE,
  FETCH_MY_COMMISSION_REPORTS_LIST_FAILED,
  FETCH_MY_COMMISSION_REPORTS_LIST_PROGRESS,
  FETCH_MY_COMMISSION_REPORTS_LIST_SUCCESS,
} from "./myCommissionReportActions";
import { LoadState } from "../../constants/enums";

export const myCommissionReportsReducer = (
  state: IStoreState["myCommissionReports"] = initialMyCommissionReportState,
  action: myCommissionReportActions
) => {
  switch (action.type) {
    case FETCH_MY_COMMISSION_REPORTS_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
        draftState.list = [];
      });
      return newState;
    }
    case FETCH_MY_COMMISSION_REPORTS_LIST_SUCCESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.list = action.payload.data;
      });
      return newState;
    }

    case FETCH_MY_COMMISSION_REPORTS_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
        draftState.list = [];
      });
      return newState;
    }

    case CLEAR_MY_COMMISSION_REPORTS_STATE: {
      return initialMyCommissionReportState;
    }

    default:
      return state;
  }
};
